import inView from 'in-view'
import $ from 'jquery'
// var Sticky = require('sticky-js');

export default function() {
    $(document).ready(function() {

    })
}
